module.exports = __webpack_public_path__ + "static/media/PCI_Compliant-Icon.29e5fca3.jpg";